import { useState, useCallback } from 'react';

export interface RecentActivityItem {
  category: string;
  id: number;
  name: string;
  action: 'added' | 'updated';
  timestamp: number;
}

const STORAGE_KEY = 'campaign-tracker-recent-activity';
const MAX_ITEMS = 20;

function loadActivity(): RecentActivityItem[] {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

export function useModificationTracker() {
  const [recentActivity, setRecentActivity] = useState<RecentActivityItem[]>(loadActivity);

  const trackModification = useCallback(
    (category: string, id: number, name: string, action: 'added' | 'updated') => {
      setRecentActivity((prev) => {
        const filtered = prev.filter(
          (item) => !(item.category === category && item.id === id)
        );
        const newItem: RecentActivityItem = {
          category,
          id,
          name,
          action,
          timestamp: Date.now(),
        };
        const updated = [newItem, ...filtered].slice(0, MAX_ITEMS);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
        return updated;
      });
    },
    []
  );

  return { recentActivity, trackModification };
}
